module.exports = __webpack_public_path__ + "images/hero_collaborators_59d0c9abbdc0bc684bd7d542dadf2de1.jpg";